import axios from "./../../http/axios";
import {
  GET_PROJECTS_BY_SCHEMAS,
  REMOVE_PROJECT,
  GET_SCHEMA_TEMPLATE,
  SET_NEW_PROJECT_INFO,
  ADD_PROJECTS_BY_SCHEMAS,
  SET_ERROR,
  SET_ERROR_OBJ,
  token, NEW_PROJECT_OPENING, EMPTY_SCHEMA_TEMPLATE
} from "./types";

export const getProjectsByAssets = user_schema => dispatch => {
  const url = `user-schemas/UserProject/${
    user_schema ? "?user_schema=" + user_schema : ""
    }`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_PROJECTS_BY_SCHEMAS,
        payload: res.data
      });
    });
};

export const addNewProject = data => dispatch => {
  const url = `user-schemas/UserProject/`;
  return axios
    .post(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: ADD_PROJECTS_BY_SCHEMAS,
        payload: res.data
      });
    });
};

export const setError = (index, error, field) => dispatch => {
  return dispatch({
    type: SET_ERROR,
    payload: {index, error, field}
  });
};

export const projectErrorsObjSet = (count) => dispatch => {
  return dispatch({
    type: SET_ERROR_OBJ,
    payload: count,
  });
};

export const editProjectAction = (data, id) => () => {
  const url = `user-schemas/UserProject/${id}/`;
  return axios
    .put(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
};


export const getSchemaTemplate = user_schema_id => dispatch => {
  const url = `user-schemas/UserSchema/${
    user_schema_id ? user_schema_id : ""
    }`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_SCHEMA_TEMPLATE,
        payload: res.data
      });
    });
};

export const setNewProjectInfo = data => dispatch => {
  return dispatch({
    type: SET_NEW_PROJECT_INFO,
    payload: data,
  });
};

export const projectNewToggle = booliean => dispatch => {
  return dispatch({
    type: NEW_PROJECT_OPENING,
    payload: booliean,
  });
};

export const emptyNewProjectSchema = () => dispatch => {
  return dispatch({
    type: EMPTY_SCHEMA_TEMPLATE,
  });
};

export const removeProject = (id, index) => dispatch => {
  const url = `user-schemas/UserProject/${id}`;
  return axios
    .delete(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(() => {
      return dispatch({
        type: REMOVE_PROJECT,
        payload: index
      });
    });
};


// WEBPACK FOOTER //
// ./src/store/actions/projects.js